export const LoginIcon = ({ className }: { className: string }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="currentColor"
        className={className}
    >
        <path d="M12.303 10.303a.43.43 0 0 0 0-.606L8.874 6.27a.43.43 0 0 0-.605 0 .43.43 0 0 0 0 .605l2.697 2.697H3.43A.43.43 0 0 0 3 10a.43.43 0 0 0 .429.429h7.537L8.27 13.126a.43.43 0 0 0 0 .605.43.43 0 0 0 .605 0l3.429-3.428ZM12 15.143a.43.43 0 0 0-.429.428A.43.43 0 0 0 12 16h2.571a2.142 2.142 0 0 0 2.143-2.143V6.143A2.142 2.142 0 0 0 14.571 4H12a.43.43 0 0 0-.429.429.43.43 0 0 0 .429.428h2.571c.71 0 1.286.576 1.286 1.286v7.714c0 .71-.576 1.286-1.286 1.286H12Z" />
    </svg>
);
